import {dateToText} from '../../util'

export default {
    methods: {
        // [METHOD] export data?
        mx_exportCsvData(fName) {
            var filename = fName || 'dataExport.csv';
            var blob, csvUrl, a;
            
            var csvArray = [];
            
            // 1. set header
            csvArray.push(this.mx_fieldsInfo.map(f=>f.text||f.value))
            // 2. set Data
            var gridData = this.mx_sharedData.gridData;
            
            csvArray = csvArray.concat(gridData.map(r=>{
                return this.mx_fieldsInfo.map(f=>{
                    var cv = f.customValue, v = r[f.value], rtn = v;
                    if(cv && typeof cv ==='function') {
                        rtn = cv(v, r);
                    }
                    switch(f.type) {
                    case 'date':
                        const opts = this.mx_options;
                        const fmt = f.dateFormat || opts.dateFormat;
                        const timezone = f.timezone===null ? opts.timezone : f.timezone;
                        rtn = dateToText(v, fmt, timezone)
                        break;
                    case 'code':
                        if(f.__domainMap) {
                            var dobj = f.__domainMap.get(v);
                            rtn = dobj?dobj.text:v;
                        }
                        break;
                    case 'boolean':
                    case 'number':
                        rtn = v;
                        break;
                    default:
                        rtn = v||"";
                    }
                    return '"'+ ((""+rtn).replace(/"/,'""')) +'"';
                })
            }))
            const BOM = "\uFEFF";
            var csvString = BOM + csvArray.map(r=>r.join(",")).join("\r\n");
            
            // IE 10, 11, Edge Run
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                blob = new Blob([decodeURIComponent(csvString)], {
                    type: 'text/csv;charset=utf8'
                });
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else if (window.Blob && window.URL) {
                // HTML5 Blob
                blob = new Blob([csvString], { type: 'text/csv;charset=utf8' });
                csvUrl = URL.createObjectURL(blob);
                a = document.createElement('a');
                a.setAttribute('style', 'display:none');
                a.setAttribute('href', csvUrl);
                a.setAttribute('download', filename);
                document.body.appendChild(a);
                a.click()
                a.remove();
            } else {
                // Data URI
                var csvData = 'data:application/csv;charset=utf-8,' + encodeURIComponent(csvString);
                a = document.createElement('a');
                a.setAttribute('style', 'display:none');
                a.setAttribute('target', '_blank');
                a.setAttribute('href', csvData);
                a.setAttribute('download', filename);
                document.body.appendChild(a);
                a.click()
                a.remove();
            }
        }
    }
}